import React, { FC } from 'react';
import { graphql } from 'gatsby';
import classnames from 'classnames';

import Button from 'components/common/Button';
import IconCustom from 'components/common/IconCustom';
import GatsbyImage from 'components/common/GatsbyImage';
import DangerouslySetInnerHtml from 'components/common/DangerouslySetInnerHtml';
import useMatchMedia from 'hooks/useMatchMedia';
import { TABLET_BREAKPOINT } from 'utils/constants';

import { IGavidigestProductBannerProps } from './model';

import './GavidigestProductBanner.scss';

const GavidigestProductBanner: FC<IGavidigestProductBannerProps> = ({
  label,
  bannerLogo,
  logoAlt,
  title,
  image,
  imageMobile,
  imageAlt,
  link: [{ name, url, target }],
  bannerTheme,
}) => {
  const isDesktop = useMatchMedia(`(min-width: ${TABLET_BREAKPOINT}px)`);

  return (
    <div
      className={classnames('gavidigest-product-banner', {
        [`gavidigest-product-banner--${bannerTheme}`]: bannerTheme,
      })}
    >
      <DangerouslySetInnerHtml className="gavidigest-product-banner__label" html={label} />
      <div className="gavidigest-product-banner__container">
        <GatsbyImage className="gavidigest-product-banner__logo" fluid={bannerLogo} alt={logoAlt} />
        <DangerouslySetInnerHtml className="gavidigest-product-banner__title" html={title} />
        <div className="gavidigest-product-banner__image">
          <GatsbyImage fluid={isDesktop ? image : imageMobile} alt={imageAlt} objectFit="contain" />
        </div>
        <div className="gavidigest-product-banner__link-wrapper">
          <Button
            to={url}
            variant="pink"
            target={target}
          >
            {name}
            <IconCustom icon="chevron-right" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment FragmentGavidigestProductBanner on TGavidigestProductBannerStructure {
    structure
    properties {
      label
      title
      bannerLogo: logo {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 500, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      logoAlt
      image {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 670, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      imageMobile {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 380, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      imageAlt
      link {
        name
        url
        target
      }
      bannerTheme
    }
  }
`;

export default GavidigestProductBanner;
